import defineComponent from 'flight';
import riot from 'riot';

let modal = {
    currentModalModel: {}
};

modal.showModal = function (tagName, model) {

    if (!this.component) {
        let component;
        defineComponent.component(function () {
            component = this;
            this.attr = {};
        });
        this.component = component;
    }

    model.close = function () {
        this.component.trigger(document, 'ui:modal:close');
    }.bind(this);

    let payload = {
        content: '<riot-modal></riot-modal>',
        cssClass: 'modal-default-new-style modal-background',
        nonDismissible: model.nonDismissible,
        beforeShow: function () {
            let tag = riot.mount('riot-modal', tagName, { model: model });
            model.update = function () {
                tag[0].update();
            };
        }
    };
    this.component.trigger(document, 'ui:modal:open', payload);

    modal.currentModalModel = model;

    return model;
};

module.exports = modal;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/context/modal.js